import { TooltipProps } from '@chakra-ui/react';
import { Omit } from 'lodash';
import * as Styles from './Tooltip.styles';

type CustomTooltipProps = Omit<TooltipProps, 'children'> & {
  children?: React.ReactNode;
};

export default function Tooltip({ children, ...props }: CustomTooltipProps): JSX.Element {
  return (
    <Styles.CustomTooltip {...props}>
      {children || <Styles.CustomInfoOutlinedIcon fontSize="small" />}
    </Styles.CustomTooltip>
  );
}
